import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-gallery" }
const _hoisted_2 = { class: "text-gallery__labelled-control" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "text-gallery__control-label" }, " Font ", -1)
const _hoisted_4 = { class: "text-gallery__labelled-control" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-gallery__control-label" }, " Color ", -1)
const _hoisted_6 = { class: "text-gallery__labelled-control" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "text-gallery__control-label" }, " Align ", -1)
const _hoisted_8 = { class: "text-gallery__labelled-control" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "text-gallery__control-label" }, " Style ", -1)

import { fonts } from '@/static/fonts'
import FontSelector from '@/components/text/FontSelector.vue'
import AlignmentSelector from '@/components/text/AlignmentSelector.vue'
import FontBackgroundSelector from '@/components/text/FontBackgroundSelector.vue'
import { TextAlign } from '@/types'
import SmallButton from '@/components/text/SmallButton.vue'
import PlusIcon from '@/assets/PlusIcon.svg'
import { useProjectStore } from '@/store/project-store'
import ColourSelector from '@/components/text/ColourSelector.vue'
import { useApplicationStore } from '@/store/application-store'
import useTextStates from '@/composables/UseTextStates'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextGallery',
  setup(__props) {

const projectStore = useProjectStore()
const applicationStore = useApplicationStore()

const textState = computed(() => applicationStore.editTextState !== 'none' ? applicationStore.currentEditingText : applicationStore.selectedText)

const onFontSelected = (fontName: string) => {
  if (textState.value) {
    textState.value.style.fontFamily = fontName
  }
}

const onAlignmentSelected = (alignment: TextAlign) => {
  if (textState.value) {
    textState.value.style.textAlign = alignment
  }
}

const onFontBackgroundColorSelected = (backgroundColor: string) => {
  if (textState.value) {
    textState.value.style.backgroundColor = backgroundColor
  }
}

const onColourSelected = (colour: string) => {
  if (textState.value) {
    textState.value.style.color = colour
  }
}

const { addText } = useTextStates()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(FontSelector, {
        fonts: _unref(fonts),
        "selected-font": _unref(textState)?.style.fontFamily ?? null,
        disabled: _unref(textState) === null,
        onFontSelected: onFontSelected
      }, null, 8, ["fonts", "selected-font", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(ColourSelector, {
        "selected-colour": _unref(textState)?.style.color ?? null,
        disabled: _unref(textState) === null,
        onColourSelected: onColourSelected
      }, null, 8, ["selected-colour", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(AlignmentSelector, {
        "selected-alignment": _unref(textState)?.style.textAlign ?? null,
        disabled: _unref(textState) === null,
        onAlignmentSelected: onAlignmentSelected
      }, null, 8, ["selected-alignment", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(FontBackgroundSelector, {
        "selected-font-background-color": _unref(textState)?.style.backgroundColor ?? null,
        disabled: _unref(textState) === null,
        onFontBackgroundColorSelected: onFontBackgroundColorSelected
      }, null, 8, ["selected-font-background-color", "disabled"])
    ]),
    _withDirectives(_createVNode(SmallButton, {
      class: "text-gallery__add-text-button",
      text: "Add text",
      "is-disabled": _unref(applicationStore).editTextState !== 'none',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(addText)({ style: _unref(applicationStore).selectedText?.style })))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(PlusIcon))
      ]),
      _: 1
    }, 8, ["is-disabled"]), [
      [_vShow, _unref(projectStore).textStates.length > 0]
    ])
  ]))
}
}

})